import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faEnvelopeOpenText,
  faPhoneVolume,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import axios from "axios";
import SimpleBanner from "../../components/common/Banner";
import toast from "react-hot-toast";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const data = JSON.stringify({
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
        status: "justConnection",
      });

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/inquiry/create-inquiry`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      const response = await axios.request(config);
      console.log(JSON.stringify(response.data));
      toast.success("Submitted succesfully");

      setSubmitStatus("success");
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (error) {
      console.log(error);
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="overflow-hidden">
      <SimpleBanner name_primary="Contact" name_secondary="Us" />
      <div className="mt-5 px-4 sm:px-8 md:px-12 lg:px-20 py-10">
        {/* Heading Section */}
        <div className="text-center">
          <h1 className="text-[#FF5E14] text-4xl font-semibold tracking-wider">
            Contact <span className="text-black">Information</span>
          </h1>
          <p className="mt-5 max-w-3xl mx-auto text-gray-500 text-lg leading-relaxed tracking-wider">
            We're here to help you with any questions or inquiries. Reach out to
            us for project consultations, support, or more information about our
            services — our team is ready to assist you.
          </p>
        </div>

        {/* Info Cards */}
        <section className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 justify-center">
          {[
            {
              icon: faLocationDot,
              title: "Location",
              text: "K7-29, KALINGA NAGAR, GHATIKIA, BHUBANESWAR-751003",
            },
            {
              icon: faEnvelopeOpenText,
              title: "Email",
              text: "covenantsdevelopers@gmail.com",
            },
            { icon: faPhoneVolume, title: "Phone", text: "7737373307, 6372664851" },
            {
              icon: faClock,
              title: "Working Hours",
              text: "Mon - Fri: 9am - 6pm",
            },
          ].map((item, index) => (
            <div
              key={index}
              className="border border-[#AEC2F6] rounded-lg p-8 flex flex-col items-center text-center gap-4 hover:shadow-lg  hover:border-[#FF5E144D]"
            >
              <FontAwesomeIcon
                icon={item.icon}
                className="text-[#FF5E14] text-4xl"
              />
              <h2 className="text-xl font-bold">{item.title}</h2>
              <p className="text-[#737588] text-base tracking-wider word-break">
                {item.text}
              </p>
            </div>
          ))}
        </section>

        {/* Map */}
        <div className="mt-16 w-full h-full">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3742.7352153195766!2d85.75840277377287!3d20.269813313415366!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a19a9d597420753%3A0x36a22530210d699d!2sCovenant%20Developers!5e0!3m2!1sen!2sin!4v1754299418597!5m2!1sen!2sin"
            width="100%"
            height="600"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        {/* Message Form */}
        <div className="mt-20 text-center">
          <h1 className="text-[#FF5E14] text-4xl font-semibold tracking-wider">
            Send Us <span className="text-black">Message</span>
          </h1>
          <p className="mt-5 max-w-3xl mx-auto text-gray-500 text-lg leading-relaxed tracking-wider">
            Have a question or need assistance? Fill out the form below and our
            team will get back to you as soon as possible. We're here to support
            you every step of the way.
          </p>

          {/* Status Messages */}
          {submitStatus === "success" && (
            <div className="mt-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded-md max-w-4xl mx-auto">
              Thank you! Your message has been sent successfully. We'll get back
              to you soon.
            </div>
          )}
          {submitStatus === "error" && (
            <div className="mt-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded-md max-w-4xl mx-auto">
              Sorry, there was an error sending your message. Please try again.
            </div>
          )}

          <form
            onSubmit={handleSubmit}
            className="mt-10 w-full max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6"
          >
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Your Name"
              className="border border-[#EAE1D6B2] h-14 rounded-md px-6 w-full"
              required
            />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Your Email"
              className="border border-[#EAE1D6B2] h-14 rounded-md px-6 w-full"
              required
            />
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              placeholder="Your Phone Number"
              className="border border-[#EAE1D6B2] h-14 rounded-md px-6 w-full col-span-1 md:col-span-2"
              required
            />
            <textarea
              rows="5"
              name="message"
              value={formData.message}
              onChange={handleInputChange}
              placeholder="Your Message"
              className="border border-[#EAE1D6B2] rounded-md px-6 py-4 w-full col-span-1 md:col-span-2 resize-none"
              required
            />
            <button
              type="submit"
              disabled={isSubmitting}
              className={`col-span-1 md:col-span-2 bg-[#FF5A3C] text-white py-3 px-10 rounded-md font-semibold hover:bg-orange-600 transition ${
                isSubmitting ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {isSubmitting ? "Sending..." : "Send"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
